"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[29901],{

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'ProximaNovaRg';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-3738f451-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 84607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 *
 * @param {number} percentNum - accept value 0 until 100
 * eg:
 * import hexOpacity from "./hexOpacity";
 *
 * ...
 * ...
 *  color: ${color.primary + hexOpacity(80)}
 * ...
 *
 */ var percentToHex = function() {
    var percentNum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return Math.round(percentNum / 100 * 255).toString(16).padStart(2, "0");
};
/* harmony default export */ __webpack_exports__["Z"] = (percentToHex);


/***/ }),

/***/ 91011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ StreamErrorModalManager; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/RegisterTradingModal.tsx
var RegisterTradingModal = __webpack_require__(15740);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/utils/hexOpacity.js
var hexOpacity = __webpack_require__(84607);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/StreamCompose/Modal/styled.ts
var styled = __webpack_require__(74319);
;// CONCATENATED MODULE: ./src/global/StreamCompose/Modal/ModalPostLimit.tsx











function ModalPostLimit(_param) {
    var onCancel = _param.onCancel, onSubmit = _param.onSubmit, type = _param.type, title = _param.title, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit",
        "type",
        "title"
    ]);
    var getDescription = function() {
        if (type === "comment") {
            return "Untuk melindungi komunitas kami, kamu perlu membuka akun Stockbit Sekuritas agar menjadi pengguna terverifikasi sebelum dapat memberikan komentar.";
        }
        return "Untuk melindungi komunitas kami, kamu perlu membuka akun Stockbit Sekuritas agar menjadi pengguna terverifikasi sebelum dapat membuat postingan.";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalConfirm */.W, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onCancel: onCancel,
        centered: true,
        closable: true,
        zIndex: 2000,
        width: 400,
        footer: // @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            pb: "20px",
            px: "20px",
            pt: "20px",
            justify: "flex-end",
            align: "flex-end",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "primary",
                // @ts-expect-error
                padding: "10px 30px",
                width: "360px",
                height: "40px",
                radius: "4px",
                onClick: onSubmit,
                children: "Buka Akun Stockbit Sekuritas"
            }, "confirm")
        }),
        maskStyle: {
            backgroundColor: "".concat(color/* default.black */.Z.black).concat((0,hexOpacity/* default */.Z)(80))
        }
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PostLimitContainer */.D, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/illustration/KYC-and-profile.svg",
                    alt: "Eipo Login Illustration",
                    width: "160",
                    height: "120"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            size: "16px",
                            weight: 700,
                            style: {
                                marginTop: 16,
                                width: title.includes("Post") ? 210 : 220,
                                lineHeight: "22px"
                            },
                            align: "center",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            align: "center",
                            size: "14px",
                            style: {
                                marginTop: 16,
                                marginBottom: 20,
                                lineHeight: "19px"
                            },
                            color: "#858585",
                            children: getDescription()
                        })
                    ]
                })
            ]
        })
    }));
}
/* harmony default export */ var Modal_ModalPostLimit = (ModalPostLimit);

// EXTERNAL MODULE: ./src/global/LinkError/index.tsx + 1 modules
var LinkError = __webpack_require__(22405);
// EXTERNAL MODULE: ./src/features/stream/ModalError/stores/useGlobalStreamError.ts
var useGlobalStreamError = __webpack_require__(20510);
;// CONCATENATED MODULE: ./src/features/stream/ModalError/ModalManager/index.tsx





function StreamErrorModalManager() {
    var modal = (0,useGlobalStreamError/* default */.Z)(function(s) {
        return s.activeModal;
    });
    var setModal = (0,useGlobalStreamError/* default */.Z)(function(s) {
        return s.openModal;
    });
    var closeModal = (0,useGlobalStreamError/* default */.Z)(function(s) {
        return s.closeModal;
    });
    var title = (0,useGlobalStreamError/* default */.Z)(function(s) {
        return s.title;
    });
    var type = (0,useGlobalStreamError/* default */.Z)(function(s) {
        return s.type;
    });
    if (!modal) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkError/* default */.Z, {
                visible: modal === useGlobalStreamError/* ModalNames.COMPOSE_ERROR_LINK */.s.COMPOSE_ERROR_LINK,
                onCancel: closeModal,
                onSubmit: function() {
                    closeModal();
                    setModal(useGlobalStreamError/* ModalNames.SECURITIES_REGISTER */.s.SECURITIES_REGISTER);
                },
                title: "Tidak Dapat Post dengan Link",
                description: "Untuk melindungi komunitas kami, kamu perlu membuka akun Stockbit Sekuritas agar menjadi pengguna terverifikasi sebelum dapat membuat postingan dengan tautan."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterTradingModal/* default */.Z, {
                visible: modal === useGlobalStreamError/* ModalNames.SECURITIES_REGISTER */.s.SECURITIES_REGISTER,
                onClose: closeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalPostLimit, {
                type: type,
                onCancel: closeModal,
                onSubmit: function() {
                    setModal(useGlobalStreamError/* ModalNames.SECURITIES_REGISTER */.s.SECURITIES_REGISTER);
                },
                visible: modal === useGlobalStreamError/* ModalNames.STREAM_POST_LIMIT */.s.STREAM_POST_LIMIT,
                title: title
            })
        ]
    });
};


/***/ }),

/***/ 20510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ModalNames; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var ModalNames;
(function(ModalNames) {
    ModalNames["COMPOSE_ERROR_LINK"] = "COMPOSE_ERROR_LINK";
    ModalNames["SECURITIES_REGISTER"] = "SECURITIES_REGISTER";
    ModalNames["STREAM_POST_LIMIT"] = "STREAM_POST_LIMIT";
})(ModalNames || (ModalNames = {}));
var useModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        activeModal: null,
        title: "",
        type: "",
        openModal: function(modalName) {
            var title = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            return set({
                activeModal: modalName,
                title: title,
                type: type
            });
        },
        closeModal: function() {
            return set({
                activeModal: null,
                title: "",
                type: ""
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useModalStore);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 79928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseSvg = function(param) {
    var _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _stroke = param.stroke, stroke = _stroke === void 0 ? "currentColor" : _stroke, _width = param.width, width = _width === void 0 ? "1em" : _width, _height = param.height, height = _height === void 0 ? "1em" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11 1.5L1 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1 1.5L11 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseSvg);


/***/ }),

/***/ 74319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ PostLimitContainer; },
/* harmony export */   "W": function() { return /* binding */ ModalConfirm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16368);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-radius: 3px 3px 0 0;\n  }\n  .ant-modal-content {\n    border-radius: 3px !important;\n  }\n  .ant-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n  }\n  button {\n    font-weight: bold;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 1.5px 0;\n  .text-container {\n    margin: 0 32px;\n    width: 336px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ModalConfirm = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-78871f8d-0"
})(_templateObject());
var PostLimitContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-78871f8d-1"
})(_templateObject1());



/***/ })

}]);